module.exports = __webpack_public_path__ + "static/media/TN.d5e93f4e.png";